<div class="service-view-layout">
    <div class="service-view-flex">
        <div class="service-view-flex-column">
            <div class="service-view-flex">
                <div class="service-view-block no-margin-top">
                    <div class="service-view-side">
                        <div class="service-view-side-header" [ngStyle]="{'height': rowAreaHeight.row1.areaHeight, 'background-color': entityData.bps.bgColor}">
                            <div class="service-view-side-header-text">Biz Process</div>                                
                        </div>
                    </div>
                    <div class="service-view-area-holder" [ngStyle]="{'height': rowAreaHeight.row1.areaHeight}">
                        <div class="service-view-area-header" [ngStyle]="{'background-color': entityData.bps.bgColor}">Insurance, BPaaS & BPO</div>
                        <div class="entity-holder-new">
                            <ng-container *ngFor="let entity of entityData.bps.data">            
                                <app-entity-new [viewType]="entityViewType" [data]="entity" [pageView]="pageView" (edit)="editEntity($event)"></app-entity-new>                                        
                            </ng-container>
                        </div>
                    </div>
                </div>
                <div class="service-view-block no-margin-top">
                    <div class="service-view-side">
                        <div class="service-view-side-header" [ngStyle]="{'height': rowAreaHeight.row1.areaHeight, 'background-color': entityData.consulting.bgColor}">
                            <div class="service-view-side-header-text">Advisory</div>                                
                        </div>
                    </div>
                    <div class="service-view-area-holder" [ngStyle]="{'height': rowAreaHeight.row1.areaHeight}">
                        <div class="service-view-area-header" [ngStyle]="{'background-color': entityData.consulting.bgColor}">Consulting</div>
                        <div class="entity-holder-new">
                            <ng-container *ngFor="let entity of entityData.consulting.data">            
                                <app-entity-new [viewType]="entityViewType" [data]="entity" [pageView]="pageView" (edit)="editEntity($event)"></app-entity-new>                                        
                            </ng-container>
                        </div>
                    </div>
                </div>
                <div class="service-view-block no-margin-top">
                    <div class="service-view-area-holder area-holder2" [ngStyle]="{'height': rowAreaHeight.row1.areaHeight}">
                        <div class="service-view-area-header" [ngStyle]="{'background-color': entityData.analysts.bgColor}">Analysts</div>
                        <div class="entity-holder-new">
                            <ng-container *ngFor="let entity of entityData.analysts.data; let even=even">            
                                <app-entity-new [ngClass]="{ 'entity-item-margin-right1': even }" [viewType]="entityViewType" [data]="entity" [pageView]="pageView" (edit)="editEntity($event)"></app-entity-new>                                        
                            </ng-container>
                        </div>
                    </div>
                </div>
            </div>
            <div class="service-view-flex">
                <div class="service-view-block">
                    <div class="service-view-side">
                        <div class="service-view-side-header" [ngStyle]="{'height': rowAreaHeight.row2.areaHeight, 'background-color': entityData.engineering.bgColor}">
                            <div class="service-view-side-header-text">Engineering</div>                                
                        </div>
                    </div>
                    <div class="service-view-area-holder" [ngStyle]="{'height': rowAreaHeight.row2.areaHeight}">
                        <div class="service-view-area-header" [ngStyle]="{'background-color': entityData.engineering.bgColor}">Engineering</div>
                        <div class="entity-holder-new">
                            <ng-container *ngFor="let entity of entityData.engineering.data">            
                                <app-entity-new [viewType]="entityViewType" [data]="entity" [pageView]="pageView" (edit)="editEntity($event)"></app-entity-new>                                        
                            </ng-container>
                        </div>
                    </div>
                </div>
                <div class="service-view-block">
                    <div class="service-view-side">
                        <div class="service-view-side-header" [ngStyle]="{'height': rowAreaHeight.row2.areaHeight, 'background-color': entityData.analytics.bgColor}">
                            <div class="service-view-side-header-text">Analytics</div>                                
                        </div>
                    </div>
                    <div class="service-view-area-holder" [ngStyle]="{'height': rowAreaHeight.row2.areaHeight}">
                        <div class="service-view-area-header" [ngStyle]="{'background-color': entityData.analytics.bgColor}">Analytics</div>
                        <div class="entity-holder-new">
                            <ng-container *ngFor="let entity of entityData.analytics.data">            
                                <app-entity-new [viewType]="entityViewType" [data]="entity" [pageView]="pageView" (edit)="editEntity($event)"></app-entity-new>                                        
                            </ng-container>
                        </div>
                    </div>
                </div>
                <div class="service-view-block">
                    <div class="service-view-side">
                        <div class="service-view-side-header" [ngStyle]="{'height': rowAreaHeight.row2.areaHeight, 'background-color': entityData.data.bgColor}">
                            <div class="service-view-side-header-text">Data Services</div>                                
                        </div>
                    </div>
                    <div class="service-view-area-holder" [ngStyle]="{'height': rowAreaHeight.row2.areaHeight}">
                        <div class="service-view-area-header" [ngStyle]="{'background-color': entityData.data.bgColor}">Information / Data / Knowledge Management</div>
                        <div class="entity-holder-new">
                            <ng-container *ngFor="let entity of entityData.data.data">            
                                <app-entity-new [viewType]="entityViewType" [data]="entity" [pageView]="pageView" (edit)="editEntity($event)"></app-entity-new>                                        
                            </ng-container>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div>
            <div class="service-view-block no-margin-top no-margin-right">
                <div class="service-view-col-side support-side">
                    <div class="service-view-col-side-header support-side-header" [ngStyle]="{'height': getC2Height(), 'background-color': entityData.systemsupport.bgColor}">
                        <div class="service-view-col-side-header-text">System Support</div>                                
                    </div>
                </div>
                <div class="service-view-area-holder area-holder1" [ngStyle]="{'height': getC2Height()}">
                    <div class="service-view-col-area-header" [ngStyle]="{'background-color': entityData.systemsupport.bgColor}">Support</div>
                    <div class="entity-holder-new">
                        <ng-container *ngFor="let entity of entityData.systemsupport.data">            
                            <app-entity-new [viewType]="entityViewType" [data]="entity" [pageView]="pageView" (edit)="editEntity($event)"></app-entity-new>                                        
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="service-view-flex">
        <div class="service-view-flex-column">
            <div class="service-view-flex">
                <div class="service-view-block">
                    <div class="service-view-side">
                        <div class="service-view-side-header" [ngStyle]="{'height': rowAreaHeight.row3.areaHeight, 'background-color': entityData.managedapp.bgColor}">
                            <div class="service-view-side-header-text">Apps</div>                                
                        </div>
                    </div>
                    <div class="service-view-area-holder" [ngStyle]="{'height': rowAreaHeight.row3.areaHeight}">
                        <div class="service-view-area-header" [ngStyle]="{'background-color': entityData.managedapp.bgColor}">Managed Applications</div>
                        <div class="entity-holder-new">
                            <ng-container *ngFor="let entity of entityData.managedapp.data">            
                                <app-entity-new [viewType]="entityViewType" [data]="entity" [pageView]="pageView" (edit)="editEntity($event)"></app-entity-new>                                        
                            </ng-container>
                        </div>
                    </div>
                </div>
                <div class="service-view-block">
                    <div class="service-view-area-holder area-holder2" [ngStyle]="{'height': rowAreaHeight.row3.areaHeight}">
                        <div class="service-view-area-header" [ngStyle]="{'background-color': entityData.enterpriseapp.bgColor}">Enterprise Applications</div>
                        <div class="entity-holder-new">
                            <ng-container *ngFor="let entity of entityData.enterpriseapp.data; let even=even">            
                                <app-entity-new [ngClass]="{ 'entity-item-margin-right1': even }" [viewType]="entityViewType" [data]="entity" [pageView]="pageView" (edit)="editEntity($event)"></app-entity-new>                                        
                            </ng-container>
                        </div>
                    </div>
                </div>
                <div class="service-view-block">
                    <div class="service-view-area-holder area-holder2" [ngStyle]="{'height': rowAreaHeight.row3.areaHeight}">
                        <div class="service-view-area-header" [ngStyle]="{'background-color': entityData.modernization.bgColor}">App Dev / Testing & Modernization</div>
                        <div class="entity-holder-new">
                            <ng-container *ngFor="let entity of entityData.modernization.data; let even=even">            
                                <app-entity-new [ngClass]="{ 'entity-item-margin-right1': even }" [viewType]="entityViewType" [data]="entity" [pageView]="pageView" (edit)="editEntity($event)"></app-entity-new>                                        
                            </ng-container>
                        </div>
                    </div>
                </div>
            </div>
            <div class="service-view-flex">
                <div class="service-view-block">
                    <div class="service-view-side">
                        <div class="service-view-side-header" [ngStyle]="{'height': rowAreaHeight.row4.areaHeight, 'background-color': entityData.iaas.bgColor}">
                            <div class="service-view-side-header-text">Cloud</div>                                
                        </div>
                    </div>
                    <div class="service-view-area-holder" [ngStyle]="{'height': rowAreaHeight.row4.areaHeight}">
                        <div class="service-view-area-header" [ngStyle]="{'background-color': entityData.iaas.bgColor}">IaaS</div>
                        <div class="entity-holder-new">
                            <ng-container *ngFor="let entity of entityData.iaas.data">            
                                <app-entity-new [viewType]="entityViewType" [data]="entity" [pageView]="pageView" (edit)="editEntity($event)"></app-entity-new>                                        
                            </ng-container>
                        </div>
                    </div>
                </div>
                <div class="service-view-block">
                    <div class="service-view-area-holder area-holder2" [ngStyle]="{'height': rowAreaHeight.row4.areaHeight}">
                        <div class="service-view-area-header" [ngStyle]="{'background-color': entityData.paas.bgColor}">PaaS</div>
                        <div class="entity-holder-new">
                            <ng-container *ngFor="let entity of entityData.paas.data; let even=even">            
                                <app-entity-new [ngClass]="{ 'entity-item-margin-right1': even }" [viewType]="entityViewType" [data]="entity" [pageView]="pageView" (edit)="editEntity($event)"></app-entity-new>                                        
                            </ng-container>
                        </div>
                    </div>
                </div>
                <div class="service-view-block">
                    <div class="service-view-area-holder area-holder2" [ngStyle]="{'height': rowAreaHeight.row4.areaHeight}">
                        <div class="service-view-area-header" [ngStyle]="{'background-color': entityData.hybrid.bgColor}">Hybrid / Multi-Cloud / Edge</div>
                        <div class="entity-holder-new">
                            <ng-container *ngFor="let entity of entityData.hybrid.data; let even=even">            
                                <app-entity-new [ngClass]="{ 'entity-item-margin-right1': even }" [viewType]="entityViewType" [data]="entity" [pageView]="pageView" (edit)="editEntity($event)"></app-entity-new>                                        
                            </ng-container>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div>
            <div class="service-view-block no-margin-right">
                <div class="service-view-col-side">
                    <div class="service-view-col-side-header" [ngStyle]="{'height': getC3Height(), 'background-color': entityData.security.bgColor}">
                        <div class="service-view-col-side-header-text"></div>                                
                    </div>
                </div>
                <div class="service-view-area-holder area-holder1" [ngStyle]="{'height': getC3Height()}">
                    <div class="service-view-col-area-header" [ngStyle]="{'background-color': entityData.security.bgColor}">Security</div>
                    <div class="entity-holder-new">
                        <ng-container *ngFor="let entity of entityData.security.data">            
                            <app-entity-new [viewType]="entityViewType" [data]="entity" [pageView]="pageView" (edit)="editEntity($event)"></app-entity-new>                                        
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="service-view-flex">
        <div class="service-view-flex-column">
            <div class="service-view-flex">
                <div class="service-view-block">
                    <div class="service-view-side">
                        <div class="service-view-side-header" [ngStyle]="{'height': rowAreaHeight.row5.areaHeight, 'background-color': entityData.server.bgColor}">
                            <div class="service-view-side-header-text">ITO</div>                                
                        </div>
                    </div>
                    <div class="service-view-area-holder" [ngStyle]="{'height': rowAreaHeight.row5.areaHeight}">
                        <div class="service-view-area-header" [ngStyle]="{'background-color': entityData.server.bgColor}">Server / Compute</div>
                        <div class="entity-holder-new">
                            <ng-container *ngFor="let entity of entityData.server.data">            
                                <app-entity-new [viewType]="entityViewType" [data]="entity" [pageView]="pageView" (edit)="editEntity($event)"></app-entity-new>                                        
                            </ng-container>
                        </div>
                    </div>
                </div>
                <div class="service-view-block">
                    <div class="service-view-area-holder area-holder1" [ngStyle]="{'height': rowAreaHeight.row5.areaHeight}">
                        <div class="service-view-area-header" [ngStyle]="{'background-color': entityData.mainframe.bgColor}">Mainframe</div>
                        <div class="entity-holder-new">
                            <ng-container *ngFor="let entity of entityData.mainframe.data">            
                                <app-entity-new [viewType]="entityViewType" [data]="entity" [pageView]="pageView" (edit)="editEntity($event)"></app-entity-new>                                        
                            </ng-container>
                        </div>
                    </div>
                </div>
                <div class="service-view-block">
                    <div class="service-view-area-holder area-holder3" [ngStyle]="{'height': rowAreaHeight.row5.areaHeight}">
                        <div class="service-view-area-header" [ngStyle]="{'background-color': entityData.storage.bgColor}">Storage Backup</div>
                        <div class="entity-holder-new">
                            <ng-container *ngFor="let entity of entityData.storage.data; let even=even">            
                                <app-entity-new [ngClass]="{ 'entity-item-margin-right2': even }" [viewType]="entityViewType" [data]="entity" [pageView]="pageView" (edit)="editEntity($event)"></app-entity-new>                                        
                            </ng-container>
                        </div>
                    </div>
                </div>
            </div>
            <div class="service-view-flex">
                <div class="service-view-block">
                    <div class="service-view-side">
                        <div class="service-view-side-header" [ngStyle]="{'height': rowAreaHeight.row6.areaHeight, 'background-color': entityData.devices.bgColor}">
                            <div class="service-view-side-header-text">Workplace</div>                                
                        </div>
                    </div>
                    <div class="service-view-area-holder" [ngStyle]="{'height': rowAreaHeight.row6.areaHeight}">
                        <div class="service-view-area-header" [ngStyle]="{'background-color': entityData.devices.bgColor}">Devices</div>
                        <div class="entity-holder-new">
                            <ng-container *ngFor="let entity of entityData.devices.data">            
                                <app-entity-new [viewType]="entityViewType" [data]="entity" [pageView]="pageView" (edit)="editEntity($event)"></app-entity-new>                                        
                            </ng-container>
                        </div>
                    </div>
                </div>
                <div class="service-view-block">
                    <div class="service-view-area-holder area-holder3" [ngStyle]="{'height': rowAreaHeight.row6.areaHeight}">
                        <div class="service-view-area-header" [ngStyle]="{'background-color': entityData.collaboration.bgColor}">Collaboration</div>
                        <div class="entity-holder-new">
                            <ng-container *ngFor="let entity of entityData.collaboration.data; let even=even">            
                                <app-entity-new [ngClass]="{ 'entity-item-margin-right2': even }" [viewType]="entityViewType" [data]="entity" [pageView]="pageView" (edit)="editEntity($event)"></app-entity-new>                                        
                            </ng-container>
                        </div>
                    </div>
                </div>
                <div class="service-view-block">
                    <div class="service-view-area-holder area-holder1" [ngStyle]="{'height': rowAreaHeight.row6.areaHeight}">
                        <div class="service-view-area-header" [ngStyle]="{'background-color': entityData.asset.bgColor}">Asset Management</div>
                        <div class="entity-holder-new">
                            <ng-container *ngFor="let entity of entityData.asset.data">            
                                <app-entity-new [viewType]="entityViewType" [data]="entity" [pageView]="pageView" (edit)="editEntity($event)"></app-entity-new>                                        
                            </ng-container>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div>
            <div class="service-view-block">
                <div class="service-view-col-side">
                    <div class="service-view-col-side-header" [ngStyle]="{'height': getC1Height(), 'background-color': entityData.network.bgColor}">
                        <div class="service-view-col-side-header-text"></div>                                
                    </div>
                </div>
                <div class="service-view-area-holder area-holder1" [ngStyle]="{'height': getC1Height()}">
                    <div class="service-view-area-header" [ngStyle]="{'background-color': entityData.network.bgColor}">Network & Telecom</div>
                    <div class="entity-holder-new">
                        <ng-container *ngFor="let entity of entityData.network.data">            
                            <app-entity-new [viewType]="entityViewType" [data]="entity" [pageView]="pageView" (edit)="editEntity($event)"></app-entity-new>                                        
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>
        <div>
            <div class="service-view-block no-margin-right">
                <div class="service-view-col-side">
                    <div class="service-view-col-side-header" [ngStyle]="{'height': getC4Height(), 'background-color': entityData.datacenter.bgColor}">
                        <div class="service-view-col-side-header-text"></div>                                
                    </div>
                </div>
                <div class="service-view-area-holder area-holder1" [ngStyle]="{'height': getC4Height()}">
                    <div class="service-view-area-header" [ngStyle]="{'background-color': entityData.datacenter.bgColor}">Data Center</div>
                    <div class="entity-holder-new">
                        <ng-container *ngFor="let entity of entityData.datacenter.data">            
                            <app-entity-new [viewType]="entityViewType" [data]="entity" [pageView]="pageView" (edit)="editEntity($event)"></app-entity-new>                                        
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
